import { MAGIC_LINK_STORAGE_TOKEN_KEY } from 'auth/domain/magicLinkToken'
import {
  type AgnosticUser,
  SG_AGNOSTIC_USER_KEY,
  SG_STORAGE_TOKEN_KEY,
  TOKEN_STORAGE_KEY,
} from 'auth/domain/User'

import { LocalStorageClient } from '../infra/storage/LocalStorageClient'

export type AnalyticsMixpanelUser = AgnosticUser & {
  id: string
  name: string
  isLoggedIn: boolean
}

function hasAnalyticsSessionToken(storage: LocalStorageClient): boolean {
  return Boolean(
    storage.get(TOKEN_STORAGE_KEY) ||
      storage.get(MAGIC_LINK_STORAGE_TOKEN_KEY) ||
      storage.get(SG_STORAGE_TOKEN_KEY)
  )
}

export function getAnalyticsUserForMixpanel(): AnalyticsMixpanelUser | null {
  const storage = new LocalStorageClient()
  const user = storage.get<AgnosticUser>(SG_AGNOSTIC_USER_KEY)

  if (!user) {
    return null
  }

  const identity = user.email ?? user.id

  return {
    ...user,
    id: identity,
    name: user.email ?? user.name ?? identity,
    isLoggedIn: hasAnalyticsSessionToken(storage),
  }
}
